import React, { useState, useEffect } from 'react';
import { fetchContent, submitContact } from '../api/api';
import './Contact.css';

const DEFAULTS = {
  title: 'Contact Us',
  address: 'Unit 6, Park Shopping Centre, Prussia Street, Dublin 7, D07K802, Ireland',
  phone: '087 100 2241',
  email: 'sales@greenwheelsscooters.ie',
  hours: '10:30am - 7:00pm, Mon - Sun',
  mapEmbed: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2381.874699587388!2d-6.287312684589385!3d53.35148997997555!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48670e9b7e5e5e5f%3A0x1!2sPark+Shopping+Centre%2C+Prussia+St%2C+Dublin+7!5e0!3m2!1sen!2sie!4v1700000000000!5m2!1sen!2sie',
  directionsUrl: 'https://maps.google.com/?q=Unit+6+Park+Shopping+Centre+Prussia+Street+Dublin+7',
};

function Contact() {
  const [contact, setContact] = useState(DEFAULTS);
  const [form, setForm] = useState({ name: '', email: '', phone: '', message: '' });
  const [status, setStatus] = useState('');

  useEffect(() => {
    fetchContent('contact')
      .then(data => setContact({ ...DEFAULTS, ...data }))
      .catch(() => setContact(DEFAULTS));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await submitContact(form);
      setStatus('Message sent successfully!');
      setForm({ name: '', email: '', phone: '', message: '' });
    } catch {
      setStatus('Failed to send message. Please try again.');
    }
  };

  return (
    <div className="contact-page section">
      <div className="container">
        <h1>{contact.title}</h1>

        <div className="contact-layout">
          {/* Left: info + form */}
          <div className="contact-left">
            <div className="contact-info-cards">
              <div className="contact-info-card">
                <span className="contact-icon">📍</span>
                <div>
                  <strong>Address</strong>
                  <p>{contact.address}</p>
                </div>
              </div>
              <div className="contact-info-card">
                <span className="contact-icon">📞</span>
                <div>
                  <strong>Phone</strong>
                  <p><a href={`tel:${contact.phone.replace(/\s/g, '')}`}>{contact.phone}</a></p>
                </div>
              </div>
              <div className="contact-info-card">
                <span className="contact-icon">✉️</span>
                <div>
                  <strong>Email</strong>
                  <p><a href={`mailto:${contact.email}`}>{contact.email}</a></p>
                </div>
              </div>
              <div className="contact-info-card">
                <span className="contact-icon">🕐</span>
                <div>
                  <strong>Hours</strong>
                  <p style={{ whiteSpace: 'pre-line' }}>{contact.hours}</p>
                </div>
              </div>
            </div>

            <form className="contact-form" onSubmit={handleSubmit}>
              <h2>Send a Message</h2>
              <input type="text" placeholder="Your Name" value={form.name}
                onChange={e => setForm({ ...form, name: e.target.value })} required />
              <input type="email" placeholder="Your Email" value={form.email}
                onChange={e => setForm({ ...form, email: e.target.value })} required />
              <input type="tel" placeholder="Your Phone Number" value={form.phone}
                onChange={e => setForm({ ...form, phone: e.target.value })} required />
              <textarea placeholder="Your Message" value={form.message}
                onChange={e => setForm({ ...form, message: e.target.value })} required />
              <button type="submit" className="btn">Send Message</button>
              {status && <p className="status">{status}</p>}
            </form>
          </div>

          {/* Right: map */}
          <div className="contact-map-wrap">
            <iframe
              key={contact.mapEmbed}
              title="Store Location"
              src={contact.mapEmbed}
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
            <a
              href={contact.directionsUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="contact-directions-btn"
            >
              📍 Get Directions
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
